<aside class="substitute-action big-input-grid-from">
  <h4 class="to"><span>Substitute</span></h4>
  <div id="substitute-search-container" [ngClass]="'grid-2'" class="separator">
    <label [ngSwitch]="this.destinationTypeControl.value" class="other-operators">
      <input *ngSwitchCase="'STRING'" type="text" [formControl]="substituteControl" required placeholder="Empty string" class="substitute-input-from">
      <input *ngSwitchDefault type="text" disabled placeholder="No field selected">
    </label>
    <span class="material-icons notranslate tooltip-icon danger" matTooltip="{{truncWarningToolTip}}" matTooltipClass="mat-tooltip">error_outline</span>
  </div>
  <h4 class="to"><span>with</span></h4>
  <div id="substitute-with-container">
    <label [ngSwitch]="this.destinationTypeControl.value" class="other-operators">
      <input *ngSwitchCase="'STRING'" type="text" [formControl]="replacementControl" placeholder="Empty string" class="substitute-input-with">
      <input *ngSwitchDefault type="text" disabled placeholder="No field selected">
    </label>
    <span class="material-icons notranslate tooltip-icon danger" matTooltip="{{truncWarningToolTip}}" matTooltipClass="mat-tooltip">error_outline</span>
  </div>
</aside>
